import { connect, MapStateToProps } from 'react-redux'
import { Props } from './InfoModalInteriorCombination'
import { closeInfoModal } from '../../redux/actions/app/infoModal.actions'
import infoModalSelector from '../../redux/selectors/infoModalSelector'
import { InfoModalData } from '../../entities/InfoModal'

type StateProps = Pick<Props, keyof InfoModalData >

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    ...infoModalSelector(state),
})

type DispatchProps = Pick<Props, 'closeInfoModal'>

const mapDispatchToProps: DispatchProps = {
    closeInfoModal,
}

export default connect(mapStateToProps, mapDispatchToProps)
